export function listSupportedCurrenciesV2(send) {
  return (...args) =>
    send(
      {
        path: '/v2/currencies',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
